(function () {
  'use strict';

  // ─── State ───────────────────────────────────────────────────────────────────
  let selectedAddons = [];
  let atcBtn = null;
  let atcTextSpan = null;
  let atcPriceSpan = null;
  let originalAtcText = '';
  let savedPriceHtml = '';
  let savedPriceCents = 0;
  let pricePrefix = 'RM';
  let isProcessing = false;

  // ─── Init ─────────────────────────────────────────────────────────────────────
  function init() {
    const block = document.querySelector('[data-pillow-addon-block]');
    if (!block) return;

    const cards = block.querySelectorAll('[data-addon-card]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () { toggleCard(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleCard(card);
        }
      });
    });

    // Zakeke button is injected dynamically — use delegation so we catch it regardless of timing
    document.addEventListener('click', handleZakezeBtnClick, true);

    // ATC button — only present on chair/non-Zakeke pages
    atcBtn = document.querySelector('button[data-add-to-cart]');
    if (!atcBtn) return;

    atcTextSpan = atcBtn.querySelector('[data-add-to-cart-text]');
    originalAtcText = atcTextSpan ? atcTextSpan.textContent.trim() : 'Add to Cart';

    atcPriceSpan = atcBtn.querySelector('[data-atc-btn-price]');
    if (atcPriceSpan) {
      pricePrefix = parsePrice(atcPriceSpan.textContent).prefix || 'RM';
    }

    atcBtn.addEventListener('click', handleAtcClick, true);

    // Auto-select cards marked by liquid — runs after ATC button is ready so price updates correctly
    cards.forEach(function (card) {
      if (card.dataset.autoSelect === 'true') {
        toggleCard(card);
      }
    });
  }

  // ─── Toggle card ─────────────────────────────────────────────────────────────
  function toggleCard(card) {
    const addon = getAddonData(card);
    const idx = selectedAddons.findIndex(function (a) { return a.productId === addon.productId; });

    if (idx === -1) {
      selectedAddons.push(addon);
      card.classList.add('is-selected');
      card.setAttribute('aria-checked', 'true');
    } else {
      selectedAddons.splice(idx, 1);
      card.classList.remove('is-selected');
      card.setAttribute('aria-checked', 'false');
    }

    updateAtcButton();
    updateBundleDiscount();
  }

  function getAddonData(card) {
    const scriptEl = card.querySelector('.js-pillow-addon-data');
    if (scriptEl) {
      try {
        const data = JSON.parse(scriptEl.textContent);
        if (data && data.zakezePid) return data;
      } catch (e) { /* fall through */ }
    }
    return {
      productId: card.dataset.productId,
      handle: card.dataset.productHandle,
      zakezePid: card.dataset.zakezePid,
      priceLabel: card.dataset.priceLabel,
      title: card.dataset.productTitle
    };
  }

  // ─── Bundle discount (neck + lumbar both selected → lumbar shows RM70) ───────
  function updateBundleDiscount() {
    var block = document.querySelector('[data-pillow-addon-block]');
    if (!block) return;
    var allCards = block.querySelectorAll('[data-addon-card]');
    var neckSel   = selectedAddons.some(function (a) { return a.handle === 'ttracing-threadmark-pillow'; });
    var lumbarSel = selectedAddons.some(function (a) { return a.handle === 'ttracing-threadmark-lumbar-pillow'; });
    var bothSelected = neckSel && lumbarSel;

    allCards.forEach(function (card) {
      var handle = card.dataset.productHandle;
      var isComboCard = handle === 'ttracing-threadmark-pillow' || handle === 'ttracing-threadmark-lumbar-pillow';
      if (!isComboCard) return;

      var existingTag = card.querySelector('.pillow-addon__combo-tag');
      if (bothSelected && !existingTag) {
        var priceEl = card.querySelector('.pillow-addon__card-price');
        if (priceEl) {
          var tag = document.createElement('span');
          tag.className = 'pillow-addon__combo-tag';
          tag.textContent = 'Combo';
          var row = document.createElement('span');
          row.className = 'pillow-addon__price-row';
          priceEl.parentNode.insertBefore(row, priceEl);
          row.appendChild(tag);
          row.appendChild(priceEl);
        }
      } else if (!bothSelected && existingTag) {
        var row = card.querySelector('.pillow-addon__price-row');
        if (row) {
          var priceEl = row.querySelector('.pillow-addon__card-price');
          if (priceEl) row.parentNode.insertBefore(priceEl, row);
          row.remove();
        }
      }
    });

    allCards.forEach(function (card) {
      var title = (card.dataset.productTitle || '').toLowerCase();
      if (title.indexOf('lumbar') === -1) return;

      var priceEl = card.querySelector('.pillow-addon__card-price');
      if (!priceEl) return;

      if (bothSelected) {
        if (!card.dataset.origPrice) {
          card.dataset.origPrice = priceEl.textContent;
        }
        priceEl.innerHTML = '<s>' + card.dataset.origPrice + '</s>'
          + '<span class="pillow-addon__card-price--discounted">RM70</span>';
      } else if (card.dataset.origPrice) {
        priceEl.textContent = card.dataset.origPrice;
      }
    });
  }

  // ─── ATC button label + price ─────────────────────────────────────────────────
  function updateAtcButton() {
    if (!atcTextSpan) return;

    if (selectedAddons.length === 0) {
      atcTextSpan.textContent = originalAtcText;
      atcBtn.classList.remove('pillow-addon-atc--active');
      if (atcPriceSpan && savedPriceHtml) {
        atcPriceSpan.innerHTML = savedPriceHtml;
        savedPriceHtml = '';
        savedPriceCents = 0;
      }
    } else {
      atcTextSpan.textContent = selectedAddons.length === 1
        ? 'Add to Cart & Customize Pillow'
        : 'Add to Cart & Customize All';
      atcBtn.classList.add('pillow-addon-atc--active');

      if (atcPriceSpan) {
        // Snapshot base price the first time an addon is selected
        if (!savedPriceHtml) {
          savedPriceHtml = atcPriceSpan.innerHTML;
          savedPriceCents = parsePrice(atcPriceSpan.textContent).cents;
        }
        var neckSel   = selectedAddons.some(function (a) { return a.handle === 'ttracing-threadmark-pillow'; });
        var lumbarSel = selectedAddons.some(function (a) { return a.handle === 'ttracing-threadmark-lumbar-pillow'; });
        var comboBoth = neckSel && lumbarSel;
        var addonTotal = selectedAddons.reduce(function (sum, a) {
          if (comboBoth && a.handle === 'ttracing-threadmark-lumbar-pillow') return sum + 7000;
          return sum + (a.priceAmount || 0);
        }, 0);
        atcPriceSpan.textContent = formatPrice(pricePrefix, savedPriceCents + addonTotal);
      }
    }
  }

  // ─── Price helpers ────────────────────────────────────────────────────────────
  function parsePrice(text) {
    var t = (text || '').trim();
    var prefix = (t.match(/^([^\d]*)/) || ['', ''])[1];
    var cents = Math.round(parseFloat(t.replace(/[^\d.]/g, '')) * 100) || 0;
    return { prefix: prefix, cents: cents };
  }

  function formatPrice(prefix, cents) {
    return prefix + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ─── Zakeke product button intercept (pillow pages) ──────────────────────────
  function handleZakezeBtnClick(e) {
    var btn = e.target.closest('button.zakeke-product-button[data-product-id]');
    if (!btn) return;
    if (selectedAddons.length === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    const pid = btn.dataset.productId;
    const handle = btn.dataset.productHandle;

    const addonChain = selectedAddons.map(function (a) {
      return { pid: a.zakezePid, handle: a.handle };
    });

    sessionStorage.setItem('_pa_addon_chain', JSON.stringify(addonChain));

    window.location.href = '/apps/zakeke?pid=' + pid
      + '&handle=' + handle
      + '&locale=en';
  }

  // ─── ATC click intercept ──────────────────────────────────────────────────────
  function handleAtcClick(e) {
    if (selectedAddons.length === 0) return;
    if (isProcessing) { e.preventDefault(); e.stopImmediatePropagation(); return; }

    const variantId = getSelectedVariantId();
    if (!variantId) return; // can't determine variant — let normal ATC proceed

    e.preventDefault();
    e.stopImmediatePropagation();

    addChairThenRedirect(variantId, getQuantity());
  }

  // ─── Add chair to cart, then redirect to Zakeke ───────────────────────────────
  async function addChairThenRedirect(variantId, quantity) {
    isProcessing = true;

    const block = document.querySelector('[data-pillow-addon-block]');
    let mainZakezePid = '';
    if (block) {
      try {
        const blockData = JSON.parse(block.querySelector('.js-pillow-addon-block-data').textContent);
        mainZakezePid = blockData.mainZakezePid || '';
      } catch (e) { /* no block data */ }
    }
    const first = selectedAddons[0];
    showRedirectOverlay(mainZakezePid ? 'Your Pillow' : first.title);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
      });

      if (!res.ok) throw new Error('status ' + res.status);

      let zakekeUrl;

      if (mainZakezePid) {
        // Pillow page: customize main product first, then chain all selected addons
        const mainHandle = (window.location.pathname.split('/products/')[1] || '').split('?')[0];
        const addonChain = selectedAddons.map(function (a) {
          return JSON.stringify({ pid: a.zakezePid, handle: a.handle });
        });
        zakekeUrl = '/apps/zakeke?pid=' + mainZakezePid
          + '&handle=' + mainHandle
          + '&locale=en'
          + '&linked_chair=' + variantId
          + '&combo_chain=' + encodeURIComponent(addonChain.join('|'));
      } else {
        // Chair page: existing behaviour — go straight to first addon, chain the rest
        zakekeUrl = '/apps/zakeke?pid=' + first.zakezePid
          + '&handle=' + first.handle
          + '&locale=en'
          + '&linked_chair=' + variantId;
        if (selectedAddons.length > 1) {
          const rest = selectedAddons.slice(1).map(function (a) {
            return JSON.stringify({ pid: a.zakezePid, handle: a.handle });
          });
          zakekeUrl += '&combo_chain=' + encodeURIComponent(rest.join('|'));
        }
      }

      window.location.href = zakekeUrl;
    } catch (err) {
      console.error('[PillowAddon] Cart add error:', err);
      isProcessing = false;
      hideRedirectOverlay();
    }
  }

  // ─── Redirect overlay ─────────────────────────────────────────────────────────
  function showRedirectOverlay(pillowTitle) {
    if (document.getElementById('pa-overlay')) return;

    var label = (pillowTitle || 'Pillow')
      .replace(/ttracing[-\s]?/i, '')
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });

    var style = document.createElement('style');
    style.id = 'pa-overlay-style';
    style.textContent = [
      '#pa-overlay{',
        'position:fixed;inset:0;',
        'background:rgba(255,255,255,0.97);',
        'display:flex;align-items:center;justify-content:center;',
        'z-index:2147483647;',
        'opacity:0;transition:opacity .2s ease;',
        'pointer-events:all;',
      '}',
      '#pa-overlay.pa-visible{opacity:1}',
      '.pa-box{text-align:center;font-family:Gotham,sans-serif;padding:32px}',
      '.pa-step{font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:#ee1b24;margin-bottom:24px}',
      '.pa-spinner{width:48px;height:48px;border:3px solid #f0f0f0;border-top-color:#ee1b24;border-radius:50%;animation:pa-spin .75s linear infinite;margin:0 auto 20px}',
      '.pa-title{font-size:16px;font-weight:700;color:#1a1a1a;margin:0 0 6px}',
      '.pa-sub{font-size:13px;color:#888;margin:0}',
      '@keyframes pa-spin{to{transform:rotate(360deg)}}'
    ].join('');

    var overlay = document.createElement('div');
    overlay.id = 'pa-overlay';
    overlay.innerHTML = [
      '<div class="pa-box">',
        '<p class="pa-step">Almost there</p>',
        '<div class="pa-spinner"></div>',
        '<p class="pa-title">Loading ' + label + ' Customizer</p>',
        '<p class="pa-sub">Adding to cart &amp; preparing your design&hellip;</p>',
      '</div>'
    ].join('');

    document.head.appendChild(style);
    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('pa-visible');
      });
    });
  }

  function hideRedirectOverlay() {
    var overlay = document.getElementById('pa-overlay');
    var style = document.getElementById('pa-overlay-style');
    if (overlay) overlay.remove();
    if (style) style.remove();
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────────
  function getSelectedVariantId() {
    const form = document.querySelector('form.product-single__form');
    if (!form) return null;
    const hidden = form.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    const sel = form.querySelector('select[data-product-select]');
    if (sel && sel.value) return sel.value;
    return null;
  }

  function getQuantity() {
    const form = document.querySelector('form.product-single__form');
    if (!form) return 1;
    const input = form.querySelector('input[name="quantity"]');
    return parseInt(input?.value || '1', 10) || 1;
  }

  // ─── Zakeke combo-chain relay ─────────────────────────────────────────────────
  // Zakeke adds to cart server-side then redirects the browser (usually to cart).
  // We pick up the chain stored in sessionStorage and forward to the next session.
  function checkComboChainRelay() {
    var chain = sessionStorage.getItem('_zk_chain');
    if (!chain) return;
    var variant = sessionStorage.getItem('_zk_lv') || '';

    sessionStorage.removeItem('_zk_chain');
    sessionStorage.removeItem('_zk_lv');

    try {
      var items = decodeURIComponent(chain).split('|').map(JSON.parse);
      var next = items[0];
      var remaining = items.slice(1);
      var nextUrl = '/apps/zakeke?pid=' + next.pid
        + '&handle=' + next.handle
        + '&locale=en'
        + (variant ? '&linked_chair=' + variant : '');
      if (remaining.length) {
        nextUrl += '&combo_chain=' + encodeURIComponent(
          remaining.map(function (r) { return JSON.stringify(r); }).join('|')
        );
      }
      showRedirectOverlay(next.handle);
      setTimeout(function () { window.location.href = nextUrl; }, 400);
    } catch (e) {
      console.error('[ZakekeChain] Relay error:', e);
    }
  }

  // ─── Bootstrap ───────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      checkComboChainRelay();
      init();
    });
  } else {
    checkComboChainRelay();
    init();
  }
})();
